import React from "react";

type Props = {
  value: string | undefined;
};
const RichTextDisplayField = ({ value }: Props) => {
  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: value ? value : "" }}></div>
    </>
  );
};

export default RichTextDisplayField;
